import { TSetFunc } from '@libs/types';
import { ConditionalRender } from '@libs/utils';
import React, { useCallback, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { ButtonPill } from '../../Buttons/ButtonPill';
import styled from './profileImage.module.css';

type TWebcamCaptureProps = {
    handleClick: (value: string) => void;
    setModal: TSetFunc;
};

const WebcamCapture = ({ handleClick, setModal }: TWebcamCaptureProps) => {
    const webcamRef = useRef<Webcam>(null);
    const [imgSrc, setImgSrc] = useState<string>('');
    const [isShowCamera, setShowCamera] = useState(true);

    const onCaptureClick = useCallback(async () => {
        const value = webcamRef?.current?.getScreenshot();
        if (value) {
            setImgSrc(value);
            setShowCamera(false);
        }
    }, [webcamRef, setImgSrc]);

    return (
        <>
            <ConditionalRender condition={isShowCamera}>
                <div className={styled.webcamContainer}>
                    <Webcam onUserMediaError={() => setModal(null)} audio={false} ref={webcamRef} screenshotFormat="image/jpeg" width={400} height={500} />
                </div>
                <div className={styled.buttonContainer}>
                    <ButtonPill isWidget={false} label="Capture photo" hierarchy="secondary" handleClick={onCaptureClick} position="inline" />
                </div>
            </ConditionalRender>
            <ConditionalRender condition={!isShowCamera && Boolean(imgSrc)}>
                <img className={styled.image} src={imgSrc} width="400" height="500" alt="Capture" />
                <div className={styled.buttonContainer}>
                    <ButtonPill isWidget={false} label="Take a photo" hierarchy="secondary" handleClick={() => setShowCamera(true)} position="inline" />
                    <ButtonPill isWidget={false} label="Upload photo" hierarchy="secondary" handleClick={() => handleClick(imgSrc)} position="inline" />
                </div>
            </ConditionalRender>
        </>
    );
};
export { WebcamCapture };
